import { render, staticRenderFns } from "./EditUpdate.vue?vue&type=template&id=48cb957e&"
import script from "./EditUpdate.vue?vue&type=script&lang=js&"
export * from "./EditUpdate.vue?vue&type=script&lang=js&"
import style0 from "./EditUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports